import React from 'react'
import { Flex, Avatar } from '@revolut/ui-kit'
import styled, { keyframes } from 'styled-components'

import { cdnLink } from '../../helpers/cdn'

const pulse = keyframes`
  0% {
    opacity: 0.1;
  }
  
  25% {
    opacity: 0.25;
  }
  
  50% {
    opacity: 0.5;
  }

  75% {
    opacity: 0.75;
  }

  100% {
    opacity: 1
  }
`

const AnimatedLogo = styled(Avatar)`
  animation: ${pulse} 1.7s ease-out infinite;
  animation-direction: alternate;
  transition: width 0.1s linear;
  transition: height 0.1s linear;
`

const LoaderWrapper = styled(Flex).attrs({
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  mx: 'auto',
  my: '3rem',
})`
  transition: opacity 450ms cubic-bezier(0.23, 1, 0.32, 1);
  width: 120px;
  height: 120px;
  position: relative;
`

export function Loader(): React.SFCElement<{}> {
  return (
    <LoaderWrapper>
      <Flex height='100%' width='100%' justifyContent='center' alignItems='center'>
        <AnimatedLogo
          size={56}
          variant='app'
          image={cdnLink('business/connect/revolut/revolut10_white.png')}
        />
      </Flex>
    </LoaderWrapper>
  )
}
